module.exports = __webpack_public_path__ + "static/media/img005.2f85d037.jpg";